import React, { useContext, useState, useEffect } from "react";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Switch, Route, Redirect, useRouteMatch, useLocation } from "react-router-dom";
import { apiGet } from "app/Services/ApiService";
import { Utils } from "common/Utils";
import { employeeApiUrls } from "common/ApiUrls";
import { PortalNames } from "common/Portals";

import Dashboard from 'area/employee/Dashboard';
import Messages from 'area/employee/Messages';
import TimeSheet from 'area/employee/TimeSheet';
import Hourbank from 'area/employee/Hourbank';
import ExcessAllocation from 'area/employee/ExcessAllocation';
import Benefits from 'area/employee/Benefits';
import Reports from 'area/employee/Reports';
import Files from 'area/employee/Files';
import Feedback from 'area/Feedback';

import Layout from "./Layout"

export default function EmployeeRoutes({ portal }) {
    const { setInsuredId } = useContext(PrivateRoutesContext);
    let { path } = useRouteMatch();
    
    useEffect(() => {
        getInsuredId();
        
        document.title = "Align Admin FringeSecure | Employee";
    },[])

    const getInsuredId = () => {
        apiGet(employeeApiUrls.getInsuredId).then((response) => {
            if (response.data === Utils.emptyGuid()) { // HACK: For some reason the InsuredId comes back as empty sometimes
                getInsuredId();
            }
            else {
                setInsuredId(response.data);
            }
        })
    }

    return (
        <Layout>
            <Switch>
                <Route exact path={`${path}/`}>
                    <Redirect to={`${path}/${PortalNames.Employee.Pages.Dashboard}`} />
                </Route>
                <Route exact path={`${path}/${PortalNames.Employee.Pages.Dashboard}`} component={Dashboard} />
                <Route exact path={`${path}/${PortalNames.Employee.Pages.Messages}`} component={Messages} />
                <Route path={`${path}/${PortalNames.Employee.Pages.TimeSheet}/:payPeriod?`} component={TimeSheet} />
                <Route exact path={`${path}/${PortalNames.Employee.Pages.Hourbank}`} component={Hourbank} />
                <Route exact path={`${path}/${PortalNames.Employee.Pages.Excess}`} component={ExcessAllocation} />
                <Route exact path={`${path}/${PortalNames.Employee.Pages.Benefits}`} component={Benefits} />
                <Route path={`${path}/${PortalNames.Employee.Pages.HWStatements}/:hwBenefitDate?`} render={() =>
                    <Reports payPeriodsUrl={employeeApiUrls.getHWPayPeriods}
                        getHWStatementUrl={(payDate, endDate) => employeeApiUrls.getHWStatement(payDate, endDate)}
                        exportUrl={employeeApiUrls.exportReport("hwStatement")}
                    />}
                />
                <Route exact path={`${path}/${PortalNames.Employee.Pages.Files}`} component={Files} />
                <Route exact path={`${path}/${PortalNames.Employee.Pages.Feedback}`} component={() => <Feedback portal={portal}/>} />
            </Switch>
      </Layout>
    )
}